'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _Popover = require('components/Popover/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hintImg = require('./csv-hint.png');

var CsvHint = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CsvHint, _Component);

  function CsvHint() {
    (0, _classCallCheck3.default)(this, CsvHint);
    return (0, _possibleConstructorReturn3.default)(this, (CsvHint.__proto__ || (0, _getPrototypeOf2.default)(CsvHint)).apply(this, arguments));
  }

  (0, _createClass3.default)(CsvHint, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          className = _props.className;

      var overlay = _react2.default.createElement(
        'div',
        { className: 'padding-5' },
        _react2.default.createElement(
          'span',
          null,
          t('Only CSV files can be uploaded. The CSV file must contain 3 columns:')
        ),
        _react2.default.createElement(
          'span',
          { className: 'bold margin-left-5' },
          'Name, Surname, Email'
        ),
        '.',
        _react2.default.createElement(
          'span',
          { className: 'margin-left-5' },
          t('Each column header must be configured as per this example.')
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: hintImg, className: 'max-width-100', alt: '' })
        )
      );

      return _react2.default.createElement(
        'span',
        { className: className },
        _react2.default.createElement(
          _Popover2.default,
          { overlay: overlay },
          _react2.default.createElement(_Button2.default, { className: 'btn-stroke small icon-info' })
        )
      );
    }
  }]);
  return CsvHint;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = CsvHint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/CsvHint.js
// module id = 1975
// module chunks = 1